import * as NavigationMenuIcons from './NavigationMenuIcons'

export const NavigationMenuIconsMap = {
  'contacts_All': NavigationMenuIcons.ContactsAll,
  'contacts_clients': NavigationMenuIcons.ContactsClients,
  'contacts_partners': NavigationMenuIcons.ContactsPartners,
  'project_Project list': NavigationMenuIcons.ProjectProjectList,
  'project_tasks': NavigationMenuIcons.ProjectTasks,
  'project_boards': NavigationMenuIcons.ProjectBoards,
  'Schedule_Work schedule': NavigationMenuIcons.ScheduleWorkSchedule,
  'Schedule_Booking table': NavigationMenuIcons.ScheduleBookingTable,
  'Finances_Invoices': NavigationMenuIcons.FinancesInvoices,
  'Finances_Payrolls': NavigationMenuIcons.FinancesPayrolls,
  'Finances_Payouts': NavigationMenuIcons.FinancesPayouts,
  'Finances_Expenses': NavigationMenuIcons.FinancesExpenses,
  'Finances_Transactions': NavigationMenuIcons.FinancesTransactions,
  'Finances_Legal entities': NavigationMenuIcons.FinancesLegalEntities,
  'Finances_Financial accounts': NavigationMenuIcons.FinancesFinancialAccounts,
  'Reports_Financial reports': NavigationMenuIcons.ReportsFinancialReports,
  'Reports_Financial dashboard': NavigationMenuIcons.ReportsFinancialDashboard,
  'Reports_P&L': NavigationMenuIcons.ReportsPL,
  'Reports_Cashflow': NavigationMenuIcons.ReportsCashflow,
  'Reports_Invoices report': NavigationMenuIcons.ReportsInvoicesReport,
  'Expenses report': NavigationMenuIcons.ExpensesReport,
  'Reports_By people & project': NavigationMenuIcons.ReportsByPeopleProject,
  'Reports_Balances report': NavigationMenuIcons.ReportsBalancesReport,
  'Reports_Operations reports': NavigationMenuIcons.ReportsOperationsReports,
  'Reports_Sales report': NavigationMenuIcons.ReportsSalesReport,
  'Reports_Hours & payments': NavigationMenuIcons.ReportsHoursPayments,
  'Reports_Time managment reports': NavigationMenuIcons.ReportsTimeManagmentReports,
  'Reports_Log time report': NavigationMenuIcons.ReportsLogTimeReport,
  'Reports_Hours tracking report': NavigationMenuIcons.ReportsHoursTrackingReport,
  'Reports_Time off report': NavigationMenuIcons.ReportsTimeOffReport,
  'Reports_KPI': NavigationMenuIcons.ReportsKPI,
  'Tenant settings_Organization': NavigationMenuIcons.TenantSettingsOrganization,
  'Tenant settings_Organization details': NavigationMenuIcons.TenantSettingsOrganizationDetails,
  'Tenant settings_System settings': NavigationMenuIcons.TenantSettingsSystemSettings,
  'Tenant settings_Plan & billing': NavigationMenuIcons.TenantSettingsPlanBilling,
  'Tenant settings_Business & operations': NavigationMenuIcons.TenantSettingsBusinessOperations,
  'Tenant settings_Legal entities': NavigationMenuIcons.TenantSettingsLegalEntities,
  'Tenant settings_Chart of accounts': NavigationMenuIcons.TenantSettingsChartOfAccounts,
  'Tenant settings_Financial accounts': NavigationMenuIcons.TenantSettingsFinancialAccounts,
  'Tenant settings_Tax types': NavigationMenuIcons.TenantSettingsTaxTypes,
  'Tenant settings_Sales channels': NavigationMenuIcons.TenantSettingsSalesChannels,
  'Tenant settings_Specialisation items': NavigationMenuIcons.TenantSettingsSpecialisationItems,
  'Tenant settings_Holidays & schedule': NavigationMenuIcons.TenantSettingsHolidaysSchedule,
  'Tenant settings_Holidays': NavigationMenuIcons.TenantSettingsHolidays,
  'Tenant settings_Time Off Settings': NavigationMenuIcons.TenantSettingsTimeOffSettings,
  'Tenant settings_Personnel & reporting': NavigationMenuIcons.TenantSettingsPersonnelReporting,
  'Tenant settings_Skills': NavigationMenuIcons.TenantSettingsSkills,
  'Tenant settings_Permissions table': NavigationMenuIcons.TenantSettingsPermissionsTable,
  'Tenant settings_Integrations': NavigationMenuIcons.TenantSettingsIntegrations,
  'Tenant settings_Integrations - Jira': NavigationMenuIcons.TenantSettingsIntegrationsJira
}
